import React, { useState, useEffect } from "react";
import BookingStatus from "./BookingStatus";
import Pet from "./Pet";
import Notification from "./Notification";
import MyInfo from "./MyInfo";
import Profile from "./Profile";
import PetSlider from "./PetSlider";
import AddPetDetails from "../AddPetDetails";
import { jwtDecode } from "jwt-decode";
 // ✅ correct import
import axios from "axios";
import { useProfile } from "../../context/ProfileContext";
import config from "../../config";

const Client = () => {
  let contact;
  let id;

  const token = localStorage.getItem("token");
  const { customerDetails } = useProfile();

  if (!token) {
    window.location.href = "https://findlocalpetservices.com/";
  } else {
    try {
      const decoded = jwtDecode(token); // ✅ decode raw token
      contact = decoded.data.customer_data.contact;
      id = decoded.data.customer_data.id;
    } catch (error) {
      console.error("Invalid token:", error);
      localStorage.removeItem("token");
      window.location.href = "https://findlocalpetservices.com/";
    }
  }

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    pincode: "",
    address: "",
    city: "",
    state: "",
  });

  const [pet_data, setPet_data] = useState([]);

  const petData = async () => {
    try {
      const token = localStorage.getItem("token");
  

      const response = await axios.post(
        `${config.API_BASE_URL}/customer/getallpet`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
   
      setPet_data(response.data.pets.length);
    } catch (error) {
      console.error("Error fetching pet data:", error.response?.data || error);
    }
  };

  const [bookings, setBookings] = useState({
    Past: [],
    Confirmed: [],
    Upcoming: [],
  });

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) return;

    try {
      const decoded = jwtDecode(token);
      const id = decoded.data.customer_data.id;

      const fetchBookings = async () => {
        try {
          const response = await axios.get(
            `${config.API_BASE_URL}/bookings/getcustomerbookings/${id}`
          );
          if (response.data.success) {
            setBookings(response.data.data);
          }
        } catch (error) {
          console.error("Error fetching bookings data:", error);
        }
      };

      fetchBookings();
    } catch (error) {
      console.error("Invalid token:", error);
    }
  }, []);

  // Sync customerDetails from ProfileContext to local formData
  useEffect(() => {
    if (customerDetails && Object.keys(customerDetails).length > 0) {
      setFormData(customerDetails);
    }
  }, [customerDetails]);

  useEffect(() => {
    petData();
  }, []);

  const [profileCompletion, setProfileCompletion] = useState(0);

  useEffect(() => {
    if (formData && typeof formData === "object") {
      const totalFields = 9;
      const filledFields = Object.values(formData).filter(
        (value) => value !== null && value !== undefined && value !== ""
      ).length;
      const percentage = (filledFields / totalFields) * 100;
      setProfileCompletion(Math.floor(percentage));
    }
  }, [formData]);

  const [showAddPetForm, setShowAddPetForm] = useState(false);

  return (
    <div className="min-h-screen bg-[#FFFCF2] p-2">
      <div className="md:w-[85%] w-[96%] mx-auto grid grid-cols-1 lg:grid-cols-3 gap-8">
        <div className="lg:col-span-1 p-2 bg-[#fff]">
          <Profile contact={contact} completion={profileCompletion} />
          <MyInfo />
          <Pet />
        </div>
        <div className="lg:col-span-2 p-4 bg-[#fff] relative">
          <Notification
            completion={profileCompletion}
            petdata={pet_data}
            past={bookings.Past.length}
            confirmed={bookings.Confirmed.length}
            upcoming={bookings.Upcoming.length}
          />
          <BookingStatus />
          <PetSlider />
        </div>
      </div>

      {showAddPetForm && (
        <div className="fixed inset-0 z-50 bg-black bg-opacity-30 flex justify-center items-center">
          <div className="bg-white p-4 rounded-md shadow-lg w-full max-w-3xl relative">
            <AddPetDetails
              onClose={() => {
                setShowAddPetForm(false);
                petData();
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default Client;
